// External doc result card — Microsoft Learn / Community with link
import { Badge } from '@/components/ui/badge'
import { ExternalLink, Globe } from 'lucide-react'

interface ExternalResultCardProps {
  title: string
  snippet?: string
  url: string
  source: string
  relevance: number
}

const SOURCE_COLORS: Record<string, string> = {
  'Microsoft Learn': 'bg-blue-50 text-blue-700 border-blue-200',
  'D365 Community': 'bg-purple-50 text-purple-700 border-purple-200',
}

export function ExternalResultCard({
  title, snippet, url, source, relevance,
}: ExternalResultCardProps): JSX.Element {
  return (
    <div className="mt-2 rounded-lg border bg-white p-3">
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2">
          <Globe className="h-4 w-4 flex-shrink-0 text-blue-500" />
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-blue-600 hover:underline"
          >
            {title}
            <ExternalLink className="ml-1 inline h-3 w-3" />
          </a>
        </div>
        <Badge variant="outline" className={`text-xs ${SOURCE_COLORS[source] ?? 'bg-gray-50 text-gray-600'}`}>
          {source}
        </Badge>
      </div>
      {snippet && <p className="mt-1 line-clamp-2 text-xs text-gray-600">{snippet}</p>}
      <div className="mt-1 text-xs text-gray-400">
        Relevance: {(relevance * 100).toFixed(0)}%
      </div>
    </div>
  )
}
